import { createSlice } from "@reduxjs/toolkit";
import { singUp } from "../../reduxApi/SingIn&SingUp/SingUpApi";

const SingUpSlice = createSlice({
  name: "SingUp",
  initialState: {
    status: "idle",
    SingUp: {},
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(singUp.pending, (state) => {
        state.status = "pending";
      })
      .addCase(singUp.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.SingUp = action.payload.data;
        console.log("Sing Up Response:", state.SingUp);
      })
      .addCase(singUp.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to fetch products";
      });
  },
});

export default SingUpSlice.reducer;
